export default __webpack_public_path__ + "static/media/Login-right-n.b0c5ddfd.png";